import React, { useState, useEffect} from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import CustomModal from "../../../UtilityComponents/customModal";
import InviteUsers from "./inviteUsers";
import DeleteUserData from "./DeleteUserData";
import { Table } from "reactstrap";
import { getUsers, deleteUser } from "../../../Redux/actions/organization";
import EmptyScreen from "../../../Assets/Empty-Screen.png";
import loader from "../../../Assets/loaderTransaparent.gif";
import empty_profile from "../../../Assets/emptyimage.png";
import "./index.css";

function People(props) {  

  let { user,organization,history } = props;  

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [ deleteUserData,setDeleteUser] = useState(false)
  const [search_data,setsearch_data] = useState()
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const invitationSuccess = async () => {
      fetchData();
      toggle();
  }
  const deleteModalToggle = async(obj)=>{
    if(obj)
    setUserData(obj)   
    setDeleteUser(!deleteUserData)
}
  const fetchData = async () => {
    setLoading(true);
    let data = await getUsers(organization.id);    
    setUsers(data)
    setLoading(false);
  }
  

  const handleDelete = async () => {
    setDeleteUser(!deleteUserData)
    await deleteUser(userData.user_id, userData.organization_id);
    fetchData();
    if(userData.email=== user.email){      
      history.push('/settings/organizations');
      window.location.reload()
    }
  }
  
  useEffect(()=>{
    setLoading(true);
    async function fetchData() {
      setLoading(true);
      let data = await getUsers(organization.id);      
      setLoading(false)
      if(data.length > 0){
        setUsers(data)
      }
    }
    setTimeout(() => fetchData(), 2000);
  },[organization]);

   const handleChange = (e) =>{    
    setsearch_data(e.target.value)
    if(e.target.value.length === 0){
      setsearch_data(null)
      fetchData()
    }
  }
  
   const handleSearch = async () =>{
    if(search_data){        
        let data = users.find((obj) =>obj.email.toString() === search_data);      
        if(data){
          setUsers([data])
        }
        else{
          setUsers([])
        }
    }else{
      let data = await getUsers(organization.id);      
      if (data.length > 0) {
        setUsers(data);
      }
    }
  }

  const keyPress = async(e) => {
    if (e.key === 'Enter' ){
      handleSearch()
    }
  }

  if(loading){
    return (
      <div className="people-container">
        <div className="people-header">
          <h5>People Management</h5>
          <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"276px",padding:"8px",marginTop:"7px"}}></i>
          <input type="text"  name="search_data" onChange={handleChange} onKeyPress={keyPress} placeholder="Search using email" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"130px"}}/>
          <button className="btn" onClick={toggle}>
            Invite
          </button>
        </div>
        <div style={{ textAlign: "center", marginTop: "15%" }}>
          <img src={loader} width="100" alt="loading"></img>
        </div>
      </div>
    );
  }else{    
    return (
      <div className="people-container">
                <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li className="breadcrumb-item" >
                          <NavLink to="/settings/organizations">
                            Organizations 
                          </NavLink>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                            People Management 
                </li>
              </ol>
            </nav>
        </div>
        <div className="people-header">
          <h5>People Management</h5>
          <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"276px",padding:"8px",marginTop:"7px"}}></i>
          <input type="text"  name="search_data" onChange={handleChange} onKeyPress={keyPress} placeholder="Search using email" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"130px"}}/>
          <button className="btn" onClick={toggle}>
            Invite
          </button>
        </div>
        {users.length > 0 ? (
          <div className="peoples-content">
            <Table hover responsive className="peoples-table">
              <thead >
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Disabled</th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="table-body">
                {users.map((obj, ind) => {
                  let name=obj.firstName && obj.lastName?obj.firstName.charAt(0).toUpperCase() + obj.lastName.charAt(0).toUpperCase():""                  
                  return (
                    <tr key={ind}>
                      <td className="username">
                        {name?
                        <div className="icon-1">{name}</div>:
                        <img 
                          src={obj.profile_pic ?obj.profile_pic : empty_profile}
                          className="rounded "
                          alt="..." />
                        }
                        <div style={{marginLeft :"50px"}}>
                          <div>{obj.firstName}</div>
                        </div>
                      </td>
                      <td><div>{obj.email}</div></td>
                      <td>{obj.role_id === 1 ? "Admin" : "Member"}</td>
                      <td>{obj.disabled ? "true" : "false"}</td>
                      <td> <i 
                            style={{ color: "red", fontSize: "1.1em" }}
                            className="fa fa-trash" data-toggle="tooltip" data-placement="top" title="Delete"
                           onClick={() => deleteModalToggle(obj)} ></i>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ) :
        users.length === 0 && search_data != null? 
        <Table hover responsive className="responsive-table" style={{backgroundColor:"#ffffff"}}>
                        <thead >
                            <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Disabled</th>
                            <th></th>                            
                            </tr>
                        </thead>
                  </Table>:(
          <div className="empty-container text-center">
            <img src={EmptyScreen} alt="empty Screen"></img>
            <p>You don't have any members in this organization yet.</p>
            <div style={{ marginTop: "10px" }}>
              <button className="btn" onClick={toggle}>
                Invite
              </button>
            </div>
          </div>
        )}

        <div>
          {modal ? <CustomModal comp={<InviteUsers toggle={() => toggle()} invitationSuccess={() => invitationSuccess()} organization={organization}/>}
                                name="Invite People"
                                toggle={() => toggle()}
                                modal={modal} /> : null } 
        </div>
        {deleteUserData?<CustomModal comp={<DeleteUserData deleteUser = {()=>handleDelete()} toggle={() => deleteModalToggle()} />}
                        name={userData.firstName?`Are you sure you want to delete User ${userData.firstName} ?`:`Are you sure you want to delete User ?`}
                        toggle={()=>deleteModalToggle()}
                        modal={deleteUserData}/>:null}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  organizations: state.organizations
});

export default connect(mapStateToProps, null)(People);
